<template>
  <div>
    <!-- Header -->
    <div class="relative flex justify-center items-center">
      <div class="absolute z-30 text-white px-6">
        <h1 class="text-4xl md:text-5xl leading-[50px] md:leading-[60px] font-serif text-center">{{ $t('events.' +
          event.id + '.title') }}</h1>
          <span v-if="$te('events.' + event.id + '.subtitle')" class="block text-2xl md:text-3xl mt-2 font-serif text-center">{{ $t('events.' +
          event.id + '.subtitle') }}</span>
      </div>
      <div class="absolute z-20 inset-0 bg-black opacity-40"></div>
      <nuxt-img sizes="xl:100vw lg:100vw md:100vw sm:100vw xs:100vw"
        class="object-cover min-h-[400px] w-full md:aspect-[3]" :src="`/images/events/${event.id}.jpg`"
        alt="Evento Hero Image" />
    </div>

    <!-- Main Content -->
    <div class="container mx-auto px-6 py-12">
      <!-- Dates Section -->
      <div class="flex flex-col gap-4">
        <div class="flex gap-4 flex-wrap">
          <span class="text-sm text-white px-2 py-1 rounded-full max-w-fit whitespace-nowrap"
            :class="{
              'bg-blue-500': event.target === 'adults',
              'bg-green-500': event.target === 'children',
              'bg-purple-500': event.target === 'teens',
              'bg-teal-500': event.target === 'youth',
              'bg-indigo-500': event.target === 'elderly',
              'bg-pink-500': event.target === 'fragile'
            }">{{
              $t('events.targets.' + event.target) }}</span>
          <span class="text-sm text-white px-2 py-1 rounded-full max-w-fit bg-[#28a745] whitespace-nowrap">{{
            $t('events.free') }}</span>
          <span class="text-sm text-white px-2 py-1 rounded-full max-w-fit bg-[#ff9800] whitespace-nowrap">{{
            $t('events.reservation_required') }}</span>
        </div>
        <span class="text-sm md:text-base text-gray-600 flex items-center">
          <Icon name="mdi:map-marker-outline" class="mr-2" />{{ $t('events.' + event.id + '.location') }}
        </span>
        <div class="flex gap-4 flex-col lg:flex-row">
          <div v-for="(date, index) in $tm('events.' + event.id + '.dates')" :key="index" v-if="!event.hide">
            <p class="text-xs md:text-sm text-gray-700 bg-gray-200 py-2 px-4 rounded-lg inline-block">
              {{ date }}
            </p>
          </div>
        </div>
      </div>
      <ClientOnly>
        <div class="py-8" v-html="$t('events.' + event.id + '.description-html')">
        </div>
      </ClientOnly>

      <!-- Swiper for Photos
      <div class="container mx-auto py-12">
        <swiper-container ref="containerRef" :init="false">
          <swiper-slide
            class="bg-tau-red text-white flex flex-col justify-center items-center p-10 md:p-20 text-center gap-5 border border-gray-100"
            v-for="(review, idx) in reviews" :key="idx">
            <h3 data-aos="fade-bottom" data-aos-duration="700">{{ $t(`home.reviews.reviews[${idx}].name`) }}</h3>
            <p data-aos="zoom-in" data-aos-duration="700" class="h-20">"{{ $t(`home.reviews.reviews[${idx}].review`) }}"
            </p>
            <span>⭐️ {{ review.rating }}/5</span>
          </swiper-slide>
        </swiper-container>
      </div> -->

      <!-- Call to Action -->
      <div class="text-center">
        <NuxtLink v-if="!isPast" to="/contacts" class="bg-tau-red block uppercase text-white py-2 px-4 rounded hover:bg-tau-red-light">
          {{ $t('events.book-btn') }}
        </NuxtLink>
        <div v-else class="bg-gray-400 block uppercase text-white py-2 px-4 rounded cursor-not-allowed">
          {{ $t('events.concluded') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/swiper-bundle.css';
import { useEventStore } from '~/stores/event'; // Adjust the path if necessary

const containerRef = ref(null)

const swiper = useSwiper(containerRef, {
  loop: false,
  pagination: true,
  slidesPerView: 1,
  autoplay: {
    delay: 5000
  },
  breakpoints: {
    1500: {
      slidesPerView: 3
    }
  }
});

const route = useRoute();
const { t } = useI18n();
const event = useEventStore().getEventById(route.params.id);

const isPast = computed(() => {
  if (!event.date) return false;
  const eventDate = new Date(event.date);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return eventDate < today;
});

</script>

<style></style>
